/* We can disable import/no-cycle here because we know that
  api only depends on the User module. */
// eslint-disable-next-line import/no-cycle
import api from '@/api';

const defaultState = () => ({
  currentNotificationId: null,
  activityDetails: {},
  loading: false,
  requirements: {},
});

const localState = defaultState();

const actions = {
  async fetch({ commit, rootState, state }) {
    // Already loaded for this notification, state should be up to date
    if (rootState.Notification.notification.id === state.currentNotificationId) return;

    commit('RESET_STATE');
    commit('SET_LOADING', true);
    await api.get(`notification/${rootState.Notification.notification.id}/activityDetails`)
      .then((response) => {
        commit('SET_ACTIVITY_DETAILS', response.data || {});
        commit('SET_CURRENT_NOTIFICATION_ID', rootState.Notification.notification.id);
        commit('SET_LOADING', false);
      })
      .catch((error) => {
        commit('SET_LOADING', false);
        throw error;
      });
  },
  async forceFetch({ commit, rootState }) {
    commit('RESET_STATE');
    commit('SET_LOADING', true);
    await api.get(`notification/${rootState.Notification.notification.id}/activityDetails`)
      .then((response) => {
        commit('SET_ACTIVITY_DETAILS', response.data || {});
        commit('SET_CURRENT_NOTIFICATION_ID', rootState.Notification.notification.id);
        commit('SET_LOADING', false);
      })
      .catch((error) => {
        commit('SET_LOADING', false);
        throw error;
      });
  },
  async create({ commit }, { data, submittedCallback }) {
    await api.post('activityDetails/create', data)
      .then((response) => {
        // The order of this spread matters, since data already has the id key.
        commit('SET_ACTIVITY_DETAILS', {
          ...data,
          id: response.data,
        });
        if (submittedCallback) submittedCallback();
      })
      .catch((error) => {
        throw error;
      });
  },
  async update({ commit }, { data, submittedCallback }) {
    await api.patch('activityDetails/update', data)
      .then(() => {
        commit('SET_ACTIVITY_DETAILS', data);
        if (submittedCallback) submittedCallback();
      });
  },
  async fetchRequirements({ commit, rootState }) {
    if (!rootState.Notification.notification.id) return;
    await api.get(`notification/${rootState.Notification.notification.id}/activityDetailsRequirements`)
      .then((response) => {
        commit('SET_REQUIREMENTS', response.data);
      });
  },
};

const mutations = {
  RESET_STATE(state) {
    Object.assign(state, defaultState());
  },
  SET_ACTIVITY_DETAILS(state, activityDetails) {
    state.activityDetails = activityDetails;
  },
  SET_CURRENT_NOTIFICATION_ID(state, id) {
    state.currentNotificationId = id;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_SUBMITTING(state, submitting) {
    state.submitting = submitting;
  },
  SET_REQUIREMENTS(state, requirements) {
    state.requirements = requirements;
  },
};

const getters = {
  roadPWLString(state) {
    const pwlArray = [];
    if (state.requirements.roadPWL1Exists) pwlArray.push('P-WL1');
    if (state.requirements.roadPWL2Exists) pwlArray.push('P-WL2');
    return pwlArray.join(' and ');
  },
};

export default {
  actions,
  getters,
  mutations,
  state: localState,
  namespaced: true,
};
